import React, { useState }  from 'react';
import TogglerBody from '../../../../template/TogglerBody';
import CustomRulesItem from './CustomRulesItem';
import { useChanges } from "../../../../../hooks/useChanges";

const CustomRules = ({ arrMassage, setArrMassage, data }) => {
    const { addChangeToStore } = useChanges();
    const [isOnMonitor, setIsOnMonitor] = useState(data?.sendRules)

        // Додавання нового правила
    const addNewRule = () => {
        const newMessages = [...arrMassage, { text: '' }];
        setArrMassage(newMessages);
        addChangeToStore({ key: 'rules', value: newMessages })
    };
    
        // Оновлення тексту правила
        const updateRuleText = (index, newText) => {
            const newMessages = arrMassage.map((item, idx) => idx === index ? { ...item, text: newText } : item)
            setArrMassage(newMessages);
            addChangeToStore({ key: 'rules', value: newMessages })
        };
    
        // Видалення правила
        const deleteRule = index => {
            const newMessages = arrMassage.filter((_, idx) => idx !== index);
            setArrMassage(newMessages);
            addChangeToStore({ key: 'rules', value: newMessages })
        };

    return (
        <div
            style={{maxWidth:'738px'}}
            className='status_block_wrap'>
            <div className='status_block_wrap_bg'></div>
            <img  className='status_block_wrap_img' src="/img/StatusBlock.svg" alt="" />
            <h3>Custom Rules Message</h3>
            <div 
            className='status_block_item'
            style={{borderBottom:'1px solid #8D99A3'}}
            >
                <div className='status_block_item_toggler'>
                    <TogglerBody
                        isOn={isOnMonitor}
                        setIsOn={setIsOnMonitor}
                        keyName={'sendRules'} />
                    <p>Use Rules Message</p>
                </div>
            </div>
            <h4 className='custom_rules_massage_title'>Rulesets</h4>
            <div className='status_block_item'>
                {arrMassage.map((item,idx) => (
                    <CustomRulesItem
                    key={idx}
                    title={idx + 1}
                    text={item.text}
                    onTextChange={(newText) => updateRuleText(idx, newText)}
                    onDelete={() => deleteRule(idx)}
                    />
                ))}
            </div>
            <div className='status_block_item status_block_item_img'>
                <img src="/img/Add.svg" alt=""  onClick={addNewRule} />
            </div>
            
        </div>
    );
};

export default CustomRules;